export const reservationConstants = {
    GETRESERVATIONS_REQUEST: 'RESERVATIONS_GETRESERVATIONS_REQUEST',
    GETRESERVATIONS_SUCCESS: 'RESERVATIONS_GETRESERVATIONS_SUCCESS',
    GETRESERVATIONS_FAILURE: 'RESERVATIONS_GETRESERVATIONS_FAILURE',

    DELETERESERVATIONS_REQUEST: 'RESERVATIONS_DELETERESERVATIONS_REQUEST',
    DELETERESERVATIONS_SUCCESS: 'RESERVATIONS_DELETERESERVATIONS_SUCCESS',
    DELETERESERVATIONS_FAILURE: 'RESERVATIONS_DELETERESERVATIONS_FAILURE',

    EDITRESERVATIONS_SETUP: 'RESERVATIONS_EDITRESERVATIONS_SETUP',
    EDITRESERVATIONS_SET: 'RESERVATIONS_EDITRESERVATIONS_SET',

    ADDRESERVATIONS_SETUP: 'RESERVATIONS_ADDRESERVATIONS_SETUP',
    ADDRESERVATIONS_SET: 'RESERVATIONS_ADDRESERVATIONS_SET',

    PATCHRESERVATIONS_REQUEST: 'RESERVATIONS_PATCHRESERVATIONS_REQUEST',
    PATCHRESERVATIONS_SUCCESS: 'RESERVATIONS_PATCHRESERVATIONS_SUCCESS',
    PATCHRESERVATIONS_FAILURE: 'RESERVATIONS_PATCHRESERVATIONS_FAILURE',

    POSTRESERVATIONS_REQUEST: 'RESERVATIONS_POSTRESERVATIONS_REQUEST',
    POSTRESERVATIONS_SUCCESS: 'RESERVATIONS_POSTRESERVATIONS_SUCCESS',
    POSTRESERVATIONS_FAILURE: 'RESERVATIONS_POSTRESERVATIONS_FAILURE',

    SEARCHCLIENTS_REQUEST: 'RESERVATIONS_SEARCHCLIENTS_REQUEST',
    SEARCHCLIENTS_SUCCESS: 'RESERVATIONS_SEARCHCLIENTS_SUCCESS',
    SEARCHCLIENTS_FAILURE: 'RESERVATIONS_SEARCHCLIENTS_FAILURE',

    LOADPLANNING_REQUEST: 'RESERVATIONS_LOADPLANNING_REQUEST',
    LOADPLANNING_SUCCESS: 'RESERVATIONS_LOADPLANNING_SUCCESS',
    LOADPLANNING_FAILURE: 'RESERVATIONS_LOADPLANNING_FAILURE',
};
